import React, { useEffect } from 'react';
// import ReactDOM  from 'react-dom';
import { observer, inject } from 'mobx-react';
import YInput from '../../../component/mobile/YInput';
import './style/step2.less';

const Step2 = inject('stepStore')(observer((props: any) => {
  useEffect(() => {
    window.parent.postMessage({height: '26rem', type: 'height'},"*");
  }, []);

  const Buttons = () => <footer className='mobile-footer'>
    <button onClick={() => props.stepStore.changeStep(3)}>提交</button>
  </footer>

  return (
    <div className='settled-step2'>
      <div className='form-container'>
        <form>
          <YInput label='联系姓名' name='name' require={true}/>
          <YInput label='联系电话' name='mobile' require={true}/>
          <YInput label='微信账号' name='wx' require={true}/>
          <YInput label='QQ账号' name='qq'/>
          <YInput label='邮箱账号' name='email'/>
        </form>
      </div>
      {/*{*/}
      <div className="button-view">
        {Buttons()}
      </div>
      {/*}*/}
      {
        // ReactDOM.createPortal(Buttons(), document.body)
      }
    </div>
  )
}))

export default Step2;